// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller.js"
application.register("accordion", AccordionController)

import AfterActionController from "./after_action_controller.js"
application.register("after-action", AfterActionController)

import AosController from "./aos_controller.js"
application.register("aos", AosController)

import ApplyAllController from "./apply_all_controller.js"
application.register("apply-all", ApplyAllController)

import AutoclickController from "./autoclick_controller.js"
application.register("autoclick", AutoclickController)

import BackController from "./back_controller.js"
application.register("back", BackController)

import BandMemoryProcessingController from "./band_memory_processing_controller.js"
application.register("band-memory-processing", BandMemoryProcessingController)

import BandMemoryUploadController from "./band_memory_upload_controller.js"
application.register("band-memory-upload", BandMemoryUploadController)

import CacheController from "./cache_controller.js"
application.register("cache", CacheController)

import CalendarController from "./calendar_controller.js"
application.register("calendar", CalendarController)

import ChartController from "./chart_controller.js"
application.register("chart", ChartController)

import CheckboxDropdownController from "./checkbox_dropdown_controller.js"
application.register("checkbox-dropdown", CheckboxDropdownController)

import CheckboxSelectAllController from "./checkbox_select_all_controller.js"
application.register("checkbox-select-all", CheckboxSelectAllController)

import ClipboardController from "./clipboard_controller.js"
application.register("clipboard", ClipboardController)

import ConnectivityController from "./connectivity_controller.js"
application.register("connectivity", ConnectivityController)

import DatepickerController from "./datepicker_controller.js"
application.register("datepicker", DatepickerController)

import DropdownController from "./dropdown_controller.js"
application.register("dropdown", DropdownController)

import ErrorsController from "./errors_controller.js"
application.register("errors", ErrorsController)

import FormController from "./form_controller.js"
application.register("form", FormController)

import FormModalController from "./form_modal_controller.js"
application.register("form-modal", FormModalController)

import GeolocatorController from "./geolocator_controller.js"
application.register("geolocator", GeolocatorController)

import HighlightController from "./highlight_controller.js"
application.register("highlight", HighlightController)

import ListController from "./list_controller.js"
application.register("list", ListController)

import MarkAsSeenController from "./mark_as_seen_controller.js"
application.register("mark-as-seen", MarkAsSeenController)

import NavController from "./nav_controller.js"
application.register("nav", NavController)

import NotificationController from "./notification_controller.js"
application.register("notification", NotificationController)

import PermissioningController from "./permissioning_controller.js";
application.register("permissioning", PermissioningController);

import PrintController from "./print_controller.js"
application.register("print", PrintController)

import RatingController from "./rating_controller.js"
application.register("rating", RatingController)

import ReloadController from "./reload_controller.js"
application.register("reload", ReloadController)

import SaveController from "./save_controller.js"
application.register("save", SaveController)

import ScrollNavController from "./scroll_nav_controller.js"
application.register("scroll-nav", ScrollNavController)

import ScrollTopController from "./scroll_top_controller.js"
application.register("scroll-top", ScrollTopController)

import SearchBasicController from "./search_basic_controller.js"
application.register("search-basic", SearchBasicController)

import SearchController from "./search_controller.js"
application.register("search", SearchController)

import Select2Controller from "./select2_controller.js"
application.register("select2", Select2Controller)

import Select3Controller from "./select3_controller.js"
application.register("select3", Select3Controller)

import SidebarController from "./sidebar_controller.js"
application.register("sidebar", SidebarController)

import SignupController from "./signup_controller.js"
application.register("signup", SignupController)

import SlideshowController from "./slideshow_controller.js"
application.register("slideshow", SlideshowController)

import SmartDebitController from "./smart_debit_controller.js"
application.register("smart-debit", SmartDebitController)

import SplideController from "./splide_controller.js"
application.register("splide", SplideController)

import CurriculumGuideController from "./curriculum_guide_controller.js"
application.register("curriculum-guide", CurriculumGuideController)

import StudentCurriculumRolloverController from "./student_curriculum_rollover_controller.js"
application.register("student-curriculum-rollover", StudentCurriculumRolloverController)

import SwitchController from "./switch_controller.js"
application.register("switch", SwitchController)

import SwitchInstrumentController from "./switch_instrument_controller.js"
application.register("switch-instrument", SwitchInstrumentController)

import TabController from "./tab_controller.js"
application.register("tab", TabController)

import TabToggleController from "./tab_toggle_controller.js"
application.register("tab-toggle", TabToggleController)

import TagController from "./tag_controller.js"
application.register("tag", TagController)

import Timetable__AssignStudentsController from "./timetable/assign_students_controller.js"
application.register("timetable--assign-students", Timetable__AssignStudentsController)

import Timetable__EditTimeSlotsController from "./timetable/edit_time_slots_controller.js"
application.register("timetable--edit-time-slots", Timetable__EditTimeSlotsController)

import Timetable__FormModalController from "./timetable/form_modal_controller.js"
application.register("timetable--form-modal", Timetable__FormModalController)

import Timetable__RearrangeLessonPlanController from "./timetable/rearrange_lesson_plan_controller.js"
application.register("timetable--rearrange-lesson-plan", Timetable__RearrangeLessonPlanController)

import Timetable__SwitchBandController from "./timetable/switch_band_controller.js"
application.register("timetable--switch-band", Timetable__SwitchBandController)

import Timetable__SwitchStudentsController from "./timetable/switch_students_controller.js"
application.register("timetable--switch-students", Timetable__SwitchStudentsController)

import Timetable__ToggleViewController from "./timetable/toggle_view_controller.js"
application.register("timetable--toggle-view", Timetable__ToggleViewController)

import Toggle2Controller from "./toggle2_controller.js"
application.register("toggle2", Toggle2Controller)

import ToggleController from "./toggle_controller.js"
application.register("toggle", ToggleController)

import TurboModalController from "./turbo_modal_controller.js"
application.register("turbo-modal", TurboModalController)

import UploadController from "./upload_controller.js"
application.register("upload", UploadController)

import VideoModalController from "./video_modal_controller.js"
application.register("video-modal", VideoModalController)
